import { Box, Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

export const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '110px',
    position: 'relative',
    left: 0,
    zIndex: 10,
    width: '100%',
    paddingRight: '80px',
    [theme.breakpoints.down('xl')]: {
      paddingRight: '40px',
    },
  },
  parent: {
    backgroundColor: '#3C8047',
    borderTopRightRadius: '365px',
    borderBottomRightRadius: '365px',
    display: 'flex',
    flexDIrection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '40px 80px 40px 80px',
    [theme.breakpoints.down('xl')]: {
      padding: '40px 40px 40px 40px',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      borderTopRightRadius: '300px',
      borderBottomRightRadius: '300px',
    },
  },
  child1: {},
  subtitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  child2: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  subtitle: {
    fontFamily: 'Playfair Display !important',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '700',
    color: '#fff',
    lineHeight: '28px',
    marginBottom: 0,
    paddingBottom: '8px',
    [theme.breakpoints.down('xl')]: {
      fontSize: '18px',
      lineHeight: '24px',
    },
  },
  title: {
    fontFamily: 'Playfair Display !important',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: '700',
    color: '#fff',
    marginBottom: 0,
    lineHeight: '54px',
    [theme.breakpoints.down('xl')]: {
      fontSize: '24px',
      lineHeight: '42px',
    },
  },
  line: {
    width: '300px',
    height: '2px',
    backgroundColor: '#fff',
    marginLeft: '25px',
    [theme.breakpoints.down('xl')]: {
      width: '150px',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  actionElement: {
    backgroundColor: '#FFB10A',
    color: '#000',
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    borderRadius: '0',

    [theme.breakpoints.down('lg')]: {
      fontSize: '14px',
      padding: '8px 16px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      padding: '6px 12px',
      marginTop: '20px',
    },
  },
}));

function GolfExperience() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.parent}>
        <Box className={classes.child1}>
          <Box className={classes.subtitleContainer}>
            <Typography className={classes.subtitle}>
              We have courses for all levels
            </Typography>
            <Box className={classes.line} />
          </Box>
          <Typography className={classes.title}>
            World Class Golf Experience
          </Typography>
        </Box>
        <Box className={classes.child2}>
          <Button className={classes.actionElement}>Golfing Experience</Button>
        </Box>
      </Box>
    </Box>
  );
}

export default GolfExperience;
